import { render, staticRenderFns } from "./Form10Layout.vue?vue&type=template&id=632e6652&scoped=true"
import script from "./Form10Layout.vue?vue&type=script&lang=ts"
export * from "./Form10Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=632e6652&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632e6652",
  null
  
)

export default component.exports